import React from 'react';
import { Link } from 'react-router-dom';
import './AppBar.css';

const AppBar = () => {
    return (
        <nav className="app-bar">
            <div className="app-bar-brand">
                <Link to="/">SeandMe</Link>
            </div>
            <div className="app-bar-links">
                <Link to="/terms">Políticas & Termos</Link>
                <Link to="/">Início</Link>
                <Link to="/delete-account" className="delete-link">Excluir Conta</Link>
            </div>
        </nav>
    );
};

export default AppBar;
